import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Durante react-snap (localhost), suprimir errores JS de la página para que no
// interrumpan el pre-rendering de las rutas siguientes (bug conocido de highland stream).
if (
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1")
) {
  window.onerror = () => true;
  window.addEventListener("unhandledrejection", (e) => e.preventDefault());
}

const rootElement = document.getElementById("root");

// Si react-snap ya generó HTML pre-renderizado, hidratamos en vez de renderizar desde cero.
// Esto evita el parpadeo y preserva el HTML que ya leyó Google.
if (rootElement.hasChildNodes()) {
  hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
